import { useSession } from '../lib/session';
import type { Theme } from '../lib/types';

const OPTIONS: Array<{ value: Theme; label: string; icon: string }> = [
  { value: 'light', label: 'Light', icon: '☀' },
  { value: 'dark', label: 'Dark', icon: '☾' },
  { value: 'system', label: 'System', icon: '◐' },
];

/** Three-way switch: an explicit choice, or follow the operating system. */
export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { theme, setTheme } = useSession();

  return (
    <div
      className="row"
      role="radiogroup"
      aria-label="Theme"
      style={{
        gap: 2,
        padding: 3,
        border: '1px solid var(--line)',
        borderRadius: 9,
        background: 'var(--surface-sunken)',
      }}
    >
      {OPTIONS.map((option) => {
        const active = theme === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            title={`${option.label} theme`}
            onClick={() => setTheme(option.value)}
            className="ui-font"
            style={{
              flex: 1,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
              padding: compact ? '5px 8px' : '6px 12px',
              fontSize: 12,
              fontWeight: 600,
              borderRadius: 6,
              border: '1px solid ' + (active ? 'var(--accent-line)' : 'transparent'),
              background: active ? 'var(--accent-quiet)' : 'transparent',
              color: active ? 'var(--text)' : 'var(--text-dim)',
            }}
          >
            <span aria-hidden>{option.icon}</span>
            {!compact && option.label}
          </button>
        );
      })}
    </div>
  );
}
